export default (isError: boolean): Record<string, unknown> => ({
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  container: (base) => ({
    ...base,
    minWidth: 74,
    minHeight: 34,
    padding: '0px 10px',
    background: ' #F3F3F3',
    borderRadius: '5px',
    transition: 'all 0.3s ease-in-out',
    boxShadow: isError ? '0 0 3px rgba(216, 0, 39, 0.8)' : 'unset',

    path: {
      stroke: isError ? 'rgba(216, 0, 39, 0.7)' : 'rgb(15, 25, 66)',
      transition: 'all 0.3s ease-in-out'
    }
  }),
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
    minHeight: 34
  }),
  singleValue: (base) => ({
    ...base,
    fontFamily: 'Verlag, sanserif',
    fontSize: 15,
    lineHeight: '18px',
    color: '#000'
  }),
  input: (base) => ({
    ...base,
    width: '100%',
    fontSize: 15,
    lineHeight: '18px',
    fontFamily: 'Verlag, sanserif',
    color: '#000'
  }),

  menu: (base) => ({
    ...base,
    zIndex: 10,
    marginTop: 2,
    marginBottom: 0,
    left: 0,
    minWidth: 74,
    background: '#fff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
    borderRadius: '0px 0px 5px 5px'
  }),

  menuList: (base) => ({
    ...base,
    overflowX: 'hidden',
    padding: 0,

    '&::-webkit-scrollbar': {
      width: '4px'
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#F2F3F6',
      borderRadius: '50px',
      width: '4px'
    },

    '&::-webkit-scrollbar-thumb': {
      background: '#D5D5D5',
      borderRadius: '3px',
      width: '6px'
    }
  }),

  option: (base, state) => ({
    ...base,
    maxHeight: 35,
    cursor: 'pointer',
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Verlag, sanserif',
    transition: 'all 0.3s ease-in-out',
    border: state.isSelected ? '1px solid rgba(7, 113, 134, 0.03)' : '1px solid #fff',
    backgroundColor: state.isSelected ? 'rgba(7, 113, 134, 0.14)' : '#fff',
    color: '#111a3f',
    fontSize: 15,
    letterSpacing: '-0.777778px',

    '&:last-child': {
      borderRadius: '0px 0px 5px 5px'
    },

    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '-1px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      height: '1px',
      background: state.isSelected ? 'rgba(7, 113, 134, 0.01)' : '#fff',
      boxShadow: ' 0px 3px 10px 0.7px rgba(0, 0, 0, 0.10)',
      transition: 'all 0.3s ease-in-out'
    },

    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: '-1px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      height: '1px',
      background: state.isSelected ? 'rgba(7, 113, 134, 0.01)' : '#fff',
      boxShadow: ' 0px 4px 10px 0.3px rgba(0, 0, 0, 0.03)',
      transition: 'all 0.3s ease-in-out'
    },

    '&:hover': {
      border: '1px solid rgba(7, 113, 134, 0.03)',
      backgroundColor: 'rgba(7, 113, 134, 0.14)',

      '&::after': {
        background: 'rgba(7, 113, 134, 0.01)'
      },

      '&::before': {
        background: 'rgba(7, 113, 134, 0.03)'
      }
    },
    '&:active': {
      backgroundColor: 'rgba(7, 113, 134, 0.14)'
    }
  }),
  placeholder: (base: React.CSSProperties) => ({
    ...base,
    fontFamily: 'Verlag, sanserif',
    fontSize: 15,
    lineHeight: 1,
    top: '51%',
    color: isError ? 'rgba(216, 0, 39, 0.7)' : '#979797',
    letterSpacing: '-0.9px',
    transition: 'all 0.3s ease-in-out'
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap'
  })
});
